import { createAction, props } from "@ngrx/store";
import { Result } from '../../shared/models/core/result.model';
import { AuditTrail } from '../../shared/models/audit_trail.model';

export const findAuditTrails = createAction(
    '[Audit Trail Management] Find Audit Trails',
    props<{ page: number, size: number, keywords: string, action?: string, excludeAction?: string, username?: string }>()
);

export const findAuditTrailsSuccess = createAction(
    '[Audit Trail Management] Find Audit Trails Success',
    props<{ auditTrails: Result<AuditTrail> }>()
);

export const findAuditTrailsError = createAction(
    '[Audit Trail Management] Find Audit Trails Error',
    props<{ error: any }>()
);


